import { getIsApiPending, getQuoteForm, getSelectedCover } from '../../../selectors/travelUg/quote';
import {
    apiTransitionTravelInsuranceQuoteForm,
    calculateTravelInsuranceAlternatePremiumSuccess,
    calculateTravelInsurancePremiumSuccess,
    triggerGetUsdRate,
} from '../../../actions/travelUg/quote';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import axios from 'axios';
import { COVER_PLANS } from '@om/redux/actions/travelUg/types';

export const premiumCalculationService = async (store, next, action) => {
    if (getIsApiPending(store.getState())) {
        return next(action);
    }

    store.dispatch(apiTransitionTravelInsuranceQuoteForm.pending());
    store.dispatch(calculateTravelInsurancePremiumSuccess(null));

    try {
        const state = store.getState();
        const selectedCover = getSelectedCover(state);

        const premiumData = await calculatePremium(state);
        store.dispatch(calculateTravelInsurancePremiumSuccess(premiumData));

        store.dispatch(apiTransitionTravelInsuranceQuoteForm.success());
        store.dispatch(calculateTravelInsuranceAlternatePremiumSuccess(null));

        if (shouldCalculateAlternatePremium(selectedCover)) {
            const alternatePremiumData = await calculatePremium(state, true);
            store.dispatch(calculateTravelInsuranceAlternatePremiumSuccess(alternatePremiumData));
        }

        store.dispatch(triggerGetUsdRate());
    } catch (error) {
        console.error(error);
        store.dispatch(apiTransitionTravelInsuranceQuoteForm.failure());
    }

    return next(action);
};

const shouldCalculateAlternatePremium = (selectedCover) => {
    if (typeof selectedCover.value !== 'string') return false;
    return (
        selectedCover.value.includes(COVER_PLANS.WORLDWIDE_COVER.title) ||
        selectedCover.value.includes(COVER_PLANS.SCHENGEN_COVER.title)
    );
};

const calculatePremium = async (state, isAlternate = false) => {
    const loginData = getAccessToken(state);
    const url = '/om-api/travel-ug/compute-premium';

    try {
        return await axios
            .post(url, generatePremiumPayload(state, isAlternate), {
                headers: {
                    'Content-Type': 'application/json',
                    accessToken: loginData.accessToken,
                },
            })
            .then((res) => res.data);
    } catch (error) {
        console.error(error);
        throw error;
    }
};

const generatePremiumPayload = (state, isAlternate = false) => {
    const quotation = getQuoteForm(state);
    const selectedCoverValue = isAlternate
        ? getAlternateCover(quotation.selectedCover.value)
        : quotation.selectedCover.value;

    return {
        cover_type: determineCoverType(selectedCoverValue, isAlternate),
        destination_area: determineAxaDestinationArea(selectedCoverValue),
        start_date: convertDateFormat(quotation.departureDate.value),
        end_date: convertDateFormat(quotation.returnDate.value),
        69: Number(quotation.adults18to69?.value) || 0,
        75: Number(quotation.adults70to75?.value) || 0,
        80: Number(quotation.adults76to80?.value) || 0,
        85: Number(quotation.adults81to85?.value) || 0,
        minors: Number(quotation.noOfMinors?.value) || 0,
    };
};

const getAlternateCover = (cover) => {
    if (cover.includes('Elite')) {
        return cover;
    }

    const alternateCoverMap = {
        'Schengen Essential': 'Schengen Elite',
        'Worldwide Essential': 'Worldwide Elite',
    };

    return alternateCoverMap[cover] || '';
};

const determineCoverType = (cover, isAlternate) => {
    const coverMap = {
        'Worldwide Essential': 'wwEssential',
        'Worldwide Elite': 'wwElite',
        'Schengen Essential': 'schengenEssential',
        'Schengen Elite': 'schengenElite',
        'Africa & Asia': 'africaAsia',
        'Student Cover': 'student',
        'Inbound Karibu': 'inbound',
    };

    if (!isAlternate) {
        const eliteToEssentialMap = {
            'Worldwide Elite': 'wwEssential',
            'Schengen Elite': 'schengenEssential',
        };

        if (eliteToEssentialMap.hasOwnProperty(cover)) {
            return eliteToEssentialMap[cover];
        }
    }

    return coverMap[cover] || '';
};

const determineAxaDestinationArea = (cover) => {
    if (typeof cover !== 'string') return 'Worldwide';

    if (cover.includes(COVER_PLANS.WORLDWIDE_COVER.title)) return 'Worldwide';
    if (cover.includes(COVER_PLANS.SCHENGEN_COVER.title)) return 'Schengen Area';

    return (
        {
            [COVER_PLANS.AFRICA_ASIA_COVER.value]: 'Africa & Asia',
            [COVER_PLANS.INBOUND_COVER.value]: 'Uganda',
            [COVER_PLANS.STUDENT_COVER.value]: 'Worldwide',
        }[cover] || 'Worldwide'
    );
};

const convertDateFormat = (dateString) => {
    if (!dateString) return '-';
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
};
